<template>
  <div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Description
            </th>
            <th class="text-right">
              Units
            </th>
            <th class="text-right">
              Unit Point
            </th>
            <th class="text-right">
              Total Points
            </th>
            <th class="text-center">
              Status
            </th>
            <th
              class="text-left"
              colspan="2"
              v-if="
                role === 'CLUBS_PERFORMANCE_EVALUATION' &&
                  project.status !== 'APPROVED'
              "
            >
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="point in points" :key="point.id">
            <td v-if="point.items">
              {{ point.items.title }}
              <small v-if="point.comment">({{ point.comment }})</small>
            </td>
            <td class="text-right">{{ point.quantity }}</td>
            <td class="text-right">{{ point.unit_point }}</td>
            <td class="text-right">{{ point.total_point }}</td>
            <td class="text-center">
              <v-chip
                x-small
                class="ma-2"
                dark
                :color="getStatusColor(point.status)"
              >
                {{ point.status }}
              </v-chip>
            </td>
            <td
              v-if="
                canManage(point.status) &&
                  point.status !== 'APPROVED' &&
                  role === 'CLUBS_PERFORMANCE_EVALUATION'
              "
            >
              <v-btn
                color="green"
                fab
                x-small
                dark
                title="Approve"
                @click="approve(point.id)"
              >
                <v-icon x-small> mdi-check </v-icon>
              </v-btn>
            </td>
            <td
              v-if="
                canManage(point.status) &&
                  point.status !== 'REJECTED' &&
                  role === 'CLUBS_PERFORMANCE_EVALUATION'
              "
            >
              <v-btn
                color="red"
                fab
                x-small
                dark
                title="Reject"
                @click="reject(point.id)"
              >
                <v-icon x-small> mdi-cancel </v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <ConfirmModalWithComment
      :title="'Reject Points'"
      :color="'red'"
      :confirmCommentOpen="confirmCommentOpen"
      @cancelCommentConfirm="cancelCommentConfirm()"
      @confirmComment="confirmComment($event)"
    ></ConfirmModalWithComment>
  </div>
</template>

<script>
import { ProjectService } from "../../../../services/project-service.js";
import { checkError } from "@/config/errors.js";
import ConfirmModalWithComment from "@/components/shared/ConfirmModalWithComment";

export default {
  name: "EstimationPoints",

  props: ["project"],
  components: { ConfirmModalWithComment },

  data: () => ({
    loading: false,
    role: localStorage.getItem("role") || null,
    confirmCommentOpen: false,
    points: [],
    updateId: null,
    uuid: null,
    form: {
      id: null,
      reject_comments: "",
      status: "",
    },
  }),

  mounted() {
    this.uuid = this.$route.params.uuid;
    this.getProjectInfo();
  },

  methods: {
    submit() {
      this.loading = true;
    },
    deleteTheme(id) {
      this.$emit("deleteTheme", id);
    },
    getStatusColor(status) {
      let bgColor = "";

      switch (true) {
        case status === "APPROVED":
          bgColor = "green";
          break;

        case status === "REJECTED":
          bgColor = "red";
          break;

        case status === "PENDING":
          bgColor = "grey darken-1";
          break;
      }
      return bgColor;
    },
    getProjectInfo() {
      if (this.uuid !== null) {
        this.loading = true;
        ProjectService.getProjectInfo(this.uuid)
          .then((response) => {
            this.loading = false;
            this.points = [];
            if (response.data.data) {
              this.points = response.data.data.projectPoints;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.points = [];
            if (error.response) {
              let data = error.response.data;
              let errorOutput = checkError.errorFormatting(data);
              this.errors = errorOutput;
            }
          });
      }
    },

    update() {
      ProjectService.updatePointsStatus(this.form)
        .then((response) => {
          this.loading = false;
          if (response.data.status_code == 200) {
            this.getProjectInfo();
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    approve(id) {
      this.updateId = id;
      this.form.reject_comments = "";
      this.form.id = this.updateId;
      this.form.status = "APPROVED";
      this.update();
    },
    reject(id) {
      this.updateId = id;
      this.confirmCommentOpen = true;
    },
    confirmComment(value) {
      this.form.id = this.updateId;
      this.form.reject_comments = value;
      this.form.status = "REJECTED";
      this.update();
      this.confirmCommentOpen = false;
    },
    cancelCommentConfirm() {
      this.confirmCommentOpen = false;
    },

    canManage() {
      if (this.project.status !== "APPROVED") {
        return true;
      }
      return false;
    },
  },
};
</script>
